/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Export_Logs_AriaInputs */



/**
* | output |
* | --- |
* | "Export Logs" |
*
* @param {Drastic_Tech_Export_Logs_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_export_logs_aria = /** @type {((inputs?: Drastic_Tech_Export_Logs_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Export_Logs_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter les journaux")
	if (locale === "de") return /** @type {LocalizedString} */ ("Protokolle exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta registri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Журналы экспорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar registros")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出日志")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ログのエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लॉग निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar registros")
	return /** @type {LocalizedString} */ ("Export Logs")
});